//import './navigation.js';
import './skip-link-focus-fix.js'
(( $ ) => {


	$(document).ready( () => {

		//haku
		$(".search-toggle").click(function(){

		  $(".search-form-wrap").slideToggle(200);

			if($(this).attr('aria-expanded') == 'false') {
				$(this).attr('aria-expanded', true);
			} else {
				$(this).attr('aria-expanded', false);
			}

			if($('#collapseSearch').attr('aria-expanded') == 'false') {
				$('#collapseSearch').attr('aria-expanded', true);
			} else {
				$('#collapseSearch').attr('aria-expanded', false);
			}

		});

		//mobiilimenu
		$("#menu-toggle").click(function(){
			$( ".mobile-nav" ).removeClass("slideOutRight");
			$( ".mobile-nav" ).addClass("block animated slideInRight");
		});

		$(".close-mobile-nav").click(function(){
			$( ".mobile-nav" ).removeClass("slideInRight");
			$( ".mobile-nav" ).addClass("slideOutRight");
		});

		$(".submenu-toggle").click(function(){
		  $(this).siblings(".sub-menu").toggleClass('active');
		});

		//yhdistykset mobiilimenu
		$(".yhdistys-mobile-toggle").click(function(){
			$(".yhdistys-sub-menu").slideToggle(200);
		});

		//kielivalinta
		/*
		$('select option:contains("FI")').text('Suomeksi');
		$('select option:contains("EN")').text('In English');
		$('select option:contains("SV")').text('På svenska');
		*/

		//Share buttons taustaväri -> Haetaan viimeisen palikan väri
		var lastItemBg = $('#main section:last-of-type').attr('class').split(' ').pop();
		$('.share-buttons-wrapper').addClass(lastItemBg);

		//tablejen wräppäys
		$('.content-area table').wrap('<div class="table-wrapper"></div>')

		//Tarinat
		$(".toggle-story-content").click(function(){
			$(this).parent().parent().siblings(".story-content").slideToggle(200);
			$(this).children(".open").slideToggle(0);
			$(this).children(".close").slideToggle(0);
		});
		$(".title-toggle-story-content").click(function(){
			$(this).parent().parent().siblings(".story-content").slideToggle(200);
			$(this).parent().siblings().children().children(".open").slideToggle(0);
			$(this).parent().siblings().children().children(".close").slideToggle(0);
		});

		// tabs
		$('#tab-nav li:first-child a').addClass('btn-pink');
		$('#tab-nav li:first-child a').attr('aria-selected',true);
		$('.tab-content').hide();
		$('.tab-content:first').show();

		$('#tab-nav li a').click(function(){
		  $(this).parent().siblings().children().removeClass('btn-pink');
		  $(this).addClass('btn-pink');
			$(this).parent().siblings().children().attr('aria-selected', false);
			$(this).attr('aria-selected', true);
		  $(this).parent().parent().siblings('.tab-content').hide();

		  var activeTab = $(this).attr('href');
		  $(activeTab).fadeIn();
		  return false;
		});

	});


	/* optional triggers

	$(window).load(() => {

	});

	$(window).resize(() => {

	});

	*/


} )( jQuery );

import './map.js'



// WEBPACK FOOTER //
// ./assets/js/app.js